import React, { useContext } from 'react';
import NumberedAccordions from '../Number/NumberedAccordions';
import AccordionWrapper from '../Accordion/AccordionWrapper';
import { QuestionEntry } from '@wix/ambassador-faq-question-entry-v2-question-entry/types';
import ListWrapper from '../List/ListsWrapper';
import { useLayoutType } from '../../../../../hooks/useLayoutType';
import { AppContext } from '../../SettingsProvider/SettingsProvider';

export type Props = {
  filteredQuestions: QuestionEntry[];
};
const SelectedLayout = ({
  filteredQuestions,
}: {
  filteredQuestions: QuestionEntry[];
}) => {
  const { isEditor3 } = useContext(AppContext);
  const {
    layout: { numberLayout, accordionLayout, listLayout },
  } = useLayoutType(isEditor3);

  return (
    <>
      {numberLayout && (
        <NumberedAccordions filteredQuestions={filteredQuestions} />
      )}
      {listLayout && <ListWrapper filteredQuestions={filteredQuestions} />}
      {accordionLayout && (
        <AccordionWrapper filteredQuestions={filteredQuestions} />
      )}
    </>
  );
};

export default SelectedLayout;
